var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import { LvsPeriod } from '@/models/LvsPeriod';
import { cloneDeep } from 'lodash';
import LoaderCard from '@/components/loader-card/LoaderCard';
let CreateTermDialog = class CreateTermDialog extends Vue {
    constructor() {
        super(...arguments);
        this.lvsPeriodClone = new LvsPeriod();
        this.formValid = false;
        this.isLoading = true;
    }
    mounted() {
        if (this.lvsPeriod && this.lvsPeriod.id) {
            this.lvsPeriodClone = cloneDeep(this.lvsPeriod);
        }
        this.isLoading = false;
    }
    closeDialog() {
        this.$emit('input', false);
    }
    async createOrUpdateLvsPeriod() {
        this.isLoading = true;
        try {
            await this.lvsPeriodClone.create({
                name: `${this.lvsPeriodClone.name}${this.lvsPeriodClone.level}`,
                level: this.lvsPeriodClone.level,
            });
            this.$emit('onCreated');
            this.$emit('input', false);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        this.isLoading = false;
    }
    get isNumberRule() {
        return (value) => {
            const pattern = /^[0-9]+$/;
            return pattern.test(value) || 'Only numbers allowed';
        };
    }
    get between1and8() {
        return (value) => {
            const pattern = /^[1-8]$/;
            // TODO Kies een niveau tussen 1 en 8
            return pattern.test(value) || 'Kies een niveau tussen 1 en 8';
        };
    }
    get required() {
        return (value) => {
            return !!value || 'Selection is required';
        };
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof LvsPeriod !== "undefined" && LvsPeriod) === "function" ? _a : Object)
], CreateTermDialog.prototype, "lvsPeriod", void 0);
CreateTermDialog = __decorate([
    Component({
        components: {
            LoaderCard,
        },
    })
], CreateTermDialog);
export default CreateTermDialog;
